var _desc, _defs, _rect, _g, _polyline, _g2, _rect2, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniQuantLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 675,
    viewBox: "0 0 1200 675",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Mini Quant Lab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Abstract chart themed banner for Mini Quant Lab.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1200,
    y2: 675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13243E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "line",
    x1: 40,
    y1: 560,
    x2: 1160,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D3EE"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    rx: 24,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24,
    stroke: "#355070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 96,
    x2: 1200,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 192,
    x2: 1200,
    y2: 192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 288,
    x2: 1200,
    y2: 288
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 384,
    x2: 1200,
    y2: 384
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 480,
    x2: 1200,
    y2: 480
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 576,
    x2: 1200,
    y2: 576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 0,
    x2: 120,
    y2: 675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 0,
    x2: 240,
    y2: 675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 0,
    x2: 360,
    y2: 675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 0,
    x2: 480,
    y2: 675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 0,
    x2: 600,
    y2: 675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 0,
    x2: 840,
    y2: 675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 0,
    x2: 960,
    y2: 675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 0,
    x2: 1080,
    y2: 675
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "70,520 190,470 300,500 410,430 520,395 640,420 760,335 870,300 980,250 1130,180",
    fill: "none",
    stroke: "url(#line)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#9CC8FF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 470,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 430,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 335,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 250,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130,
    cy: 180,
    r: 8
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 68,
    width: 286,
    height: 44,
    rx: 22,
    fill: "#1E3A8A",
    fillOpacity: 0.55
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 97,
    fill: "#BFDBFE",
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700
  }, "Cloud + Quant Demo")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 605,
    fill: "#F8FAFC",
    fontFamily: "Arial, sans-serif",
    fontSize: 56,
    fontWeight: 700
  }, "Mini Quant Lab")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 640,
    fill: "#C7D2FE",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 500
  }, "NumPy, Pandas, backtesting, and interactive strategy controls")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniQuantLab);
export default __webpack_public_path__ + "static/media/mini-quant-lab.2714b43de50cf92031db0f49f3ec21b4.svg";
export { ForwardRef as ReactComponent };